var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1038,
    height: 189,
    viewBox: "0 0 1038 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1038V189H0V0Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 159.5,
    x2: 1016.27,
    y2: 159.5,
    stroke: "#E6E6E6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 129.5,
    x2: 1016.27,
    y2: 129.5,
    stroke: "#E6E6E6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 99.5,
    x2: 1016.27,
    y2: 99.4999,
    stroke: "#E6E6E6"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 69.5,
    x2: 1016.27,
    y2: 69.4999,
    stroke: "#E6E6E6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 39.5,
    x2: 1016.27,
    y2: 39.4999,
    stroke: "#E6E6E6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 9.5,
    x2: 1016.27,
    y2: 9.49992,
    stroke: "#E6E6E6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 77.5,
    y1: 10,
    x2: 77.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 161.5,
    y1: 10,
    x2: 161.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 246.5,
    y1: 10,
    x2: 246.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 331.5,
    y1: 10,
    x2: 331.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: 10,
    x2: 416.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 501.5,
    y1: 10,
    x2: 501.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 584.5,
    y1: 10,
    x2: 584.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 667.5,
    y1: 10,
    x2: 667.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 753.5,
    y1: 10,
    x2: 753.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 838.5,
    y1: 10,
    x2: 838.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 922.5,
    y1: 10,
    x2: 922.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1008.5,
    y1: 10,
    x2: 1008.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M490.534 75.48V90H488.356L482.284 80.276L480.744 77.548H480.722L480.81 79.748V90H479.138V75.48H481.316L487.366 85.16L488.928 87.954H488.95L488.862 85.732V75.48H490.534ZM499.346 78.78C500.387 78.78 501.304 79.0073 502.096 79.462C502.903 79.9167 503.533 80.5767 503.988 81.442C504.443 82.2927 504.67 83.312 504.67 84.5C504.67 85.688 504.443 86.7147 503.988 87.58C503.533 88.4307 502.903 89.0833 502.096 89.538C501.304 89.9927 500.387 90.22 499.346 90.22C498.319 90.22 497.403 89.9927 496.596 89.538C495.789 89.0833 495.159 88.4307 494.704 87.58C494.249 86.7147 494.022 85.688 494.022 84.5C494.022 83.312 494.249 82.2927 494.704 81.442C495.159 80.5767 495.789 79.9167 496.596 79.462C497.403 79.0073 498.319 78.78 499.346 78.78ZM499.346 80.298C498.598 80.298 497.96 80.4667 497.432 80.804C496.904 81.1413 496.493 81.6253 496.2 82.256C495.921 82.872 495.782 83.62 495.782 84.5C495.782 85.3653 495.921 86.1133 496.2 86.744C496.493 87.3747 496.904 87.8587 497.432 88.196C497.96 88.5333 498.598 88.702 499.346 88.702C500.094 88.702 500.732 88.5333 501.26 88.196C501.788 87.8587 502.191 87.3747 502.47 86.744C502.763 86.1133 502.91 85.3653 502.91 84.5C502.91 83.62 502.763 82.872 502.47 82.256C502.191 81.6253 501.788 81.1413 501.26 80.804C500.732 80.4667 500.094 80.298 499.346 80.298ZM520.498 75.48C522.771 75.48 524.553 76.1107 525.844 77.372C527.149 78.6187 527.802 80.408 527.802 82.74C527.802 85.072 527.149 86.8687 525.844 88.13C524.553 89.3767 522.771 90 520.498 90H515.812V75.48H520.498ZM520.674 88.35C522.331 88.35 523.622 87.8587 524.546 86.876C525.484 85.8787 525.954 84.5 525.954 82.74C525.954 80.98 525.484 79.6087 524.546 78.626C523.622 77.6287 522.331 77.13 520.674 77.13H517.572V88.35H520.674ZM537.761 82.894C537.761 82.0727 537.541 81.442 537.101 81.002C536.661 80.5473 536.038 80.32 535.231 80.32C534.468 80.32 533.823 80.4887 533.295 80.826C532.767 81.1487 532.378 81.6767 532.129 82.41L530.699 81.53C530.992 80.7087 531.535 80.0487 532.327 79.55C533.119 79.0367 534.102 78.78 535.275 78.78C536.067 78.78 536.786 78.9193 537.431 79.198C538.076 79.462 538.582 79.8727 538.949 80.43C539.33 80.9727 539.521 81.6767 539.521 82.542V87.866C539.521 88.394 539.8 88.658 540.357 88.658C540.636 88.658 540.907 88.6213 541.171 88.548L541.083 89.934C540.79 90.0807 540.408 90.154 539.939 90.154C539.514 90.154 539.132 90.0733 538.795 89.912C538.458 89.7507 538.194 89.5087 538.003 89.186C537.812 88.8487 537.717 88.4307 537.717 87.932V87.712L538.157 87.778C537.981 88.35 537.68 88.8193 537.255 89.186C536.83 89.538 536.353 89.802 535.825 89.978C535.297 90.1393 534.776 90.22 534.263 90.22C533.618 90.22 533.016 90.11 532.459 89.89C531.902 89.67 531.454 89.34 531.117 88.9C530.794 88.4453 530.633 87.888 530.633 87.228C530.633 86.4067 530.904 85.732 531.447 85.204C532.004 84.6613 532.774 84.2947 533.757 84.104L538.113 83.246V84.698L534.571 85.424C533.852 85.5707 533.317 85.776 532.965 86.04C532.613 86.304 532.437 86.6707 532.437 87.14C532.437 87.5947 532.613 87.9687 532.965 88.262C533.332 88.5407 533.845 88.68 534.505 88.68C534.93 88.68 535.334 88.6287 535.715 88.526C536.111 88.4087 536.463 88.24 536.771 88.02C537.079 87.7853 537.321 87.4993 537.497 87.162C537.673 86.81 537.761 86.3993 537.761 85.93V82.894ZM545.964 75.876V86.964C545.964 87.5067 546.118 87.91 546.426 88.174C546.734 88.438 547.13 88.57 547.614 88.57C548.04 88.57 548.406 88.4967 548.714 88.35C549.022 88.2033 549.301 88.0053 549.55 87.756L550.166 89.23C549.829 89.538 549.426 89.78 548.956 89.956C548.502 90.132 547.974 90.22 547.372 90.22C546.815 90.22 546.294 90.1247 545.81 89.934C545.326 89.7287 544.938 89.4133 544.644 88.988C544.366 88.548 544.219 87.976 544.204 87.272V76.36L545.964 75.876ZM549.968 79V80.518H542.004V79H549.968ZM559.009 82.894C559.009 82.0727 558.789 81.442 558.349 81.002C557.909 80.5473 557.286 80.32 556.479 80.32C555.716 80.32 555.071 80.4887 554.543 80.826C554.015 81.1487 553.626 81.6767 553.377 82.41L551.947 81.53C552.24 80.7087 552.783 80.0487 553.575 79.55C554.367 79.0367 555.35 78.78 556.523 78.78C557.315 78.78 558.034 78.9193 558.679 79.198C559.324 79.462 559.83 79.8727 560.197 80.43C560.578 80.9727 560.769 81.6767 560.769 82.542V87.866C560.769 88.394 561.048 88.658 561.605 88.658C561.884 88.658 562.155 88.6213 562.419 88.548L562.331 89.934C562.038 90.0807 561.656 90.154 561.187 90.154C560.762 90.154 560.38 90.0733 560.043 89.912C559.706 89.7507 559.442 89.5087 559.251 89.186C559.06 88.8487 558.965 88.4307 558.965 87.932V87.712L559.405 87.778C559.229 88.35 558.928 88.8193 558.503 89.186C558.078 89.538 557.601 89.802 557.073 89.978C556.545 90.1393 556.024 90.22 555.511 90.22C554.866 90.22 554.264 90.11 553.707 89.89C553.15 89.67 552.702 89.34 552.365 88.9C552.042 88.4453 551.881 87.888 551.881 87.228C551.881 86.4067 552.152 85.732 552.695 85.204C553.252 84.6613 554.022 84.2947 555.005 84.104L559.361 83.246V84.698L555.819 85.424C555.1 85.5707 554.565 85.776 554.213 86.04C553.861 86.304 553.685 86.6707 553.685 87.14C553.685 87.5947 553.861 87.9687 554.213 88.262C554.58 88.5407 555.093 88.68 555.753 88.68C556.178 88.68 556.582 88.6287 556.963 88.526C557.359 88.4087 557.711 88.24 558.019 88.02C558.327 87.7853 558.569 87.4993 558.745 87.162C558.921 86.81 559.009 86.3993 559.009 85.93V82.894Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartEmpty);
export default __webpack_public_path__ + "static/media/chart_empty.2708b2e3.svg";
export { ForwardRef as ReactComponent };